import { motion } from "framer-motion";

const PAUL =
  "https://customer-assets-agu9un31.emergentagent.net/job_outdoors-reimagined/artifacts/c8zu69r9_paul%20bass.jpg";
const BOB =
  "https://customer-assets-agu9un31.emergentagent.net/job_outdoors-reimagined/artifacts/9r17po5d_d4e7c833-7ed6-49cb-bb4e-83c79a376b41.jpg";

const FOUNDERS = [
  {
    name: "Paul",
    role: "Co-Founder",
    img: PAUL,
    line: "On the water before sunrise, chasing the next personal best.",
    testid: "founder-paul",
  },
  {
    name: "Bob",
    role: "Co-Founder",
    img: BOB,
    line: "A lifetime outdoorsman with a net always within reach.",
    testid: "founder-bob",
  },
];

const EASE = [0.16, 1, 0.3, 1];

const FounderCard = ({ founder, index }) => (
  <motion.article
    data-testid={founder.testid}
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.3 }}
    transition={{ duration: 0.9, ease: EASE, delay: index * 0.12 }}
    className="group relative"
  >
    {/* Number chapter marker */}
    <span className="mb-4 block font-body text-xs uppercase tracking-[0.4em] text-[#c6a664]/70">
      {`0${index + 1}`} — {founder.role}
    </span>

    <div className="relative overflow-hidden rounded-sm border border-[#c6a664]/20 bg-[#0a130e]">
      {/* Spotlight wash on hover */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 z-10 bg-[radial-gradient(circle_at_50%_20%,rgba(198,166,100,0.18),transparent_55%)] opacity-0 transition-opacity duration-700 group-hover:opacity-100"
      />
      <div className="aspect-[3/4] w-full overflow-hidden">
        <img
          src={founder.img}
          alt={`${founder.name}, ${founder.role} of Outdoors Reimagined`}
          data-testid={`${founder.testid}-image`}
          className="h-full w-full object-cover object-center grayscale-[0.15] transition-transform duration-[1200ms] ease-out group-hover:scale-105"
          loading="lazy"
        />
      </div>
      {/* Bottom gradient + caption */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-x-0 bottom-0 z-[5] h-2/3 bg-gradient-to-t from-[#0a130e] via-[#0a130e]/70 to-transparent"
      />
      <div className="absolute inset-x-0 bottom-0 z-20 flex items-end justify-between gap-4 p-6 md:p-8">
        <div>
          <h3 className="font-display text-4xl font-light leading-none text-[#f4f1ed] md:text-5xl">
            {founder.name}
          </h3>
          <p className="mt-3 max-w-xs font-body text-sm leading-relaxed text-[#a3b1a9]">
            {founder.line}
          </p>
        </div>
        <span className="mb-2 h-px w-10 shrink-0 bg-[#c6a664]/60" />
      </div>
    </div>
  </motion.article>
);

export const CoFounders = () => {
  return (
    <section
      id="founders"
      data-testid="cofounders-section"
      className="relative z-10 w-full bg-[#0f1c16] px-6 py-24 md:px-12 md:py-36"
    >
      {/* Section heading */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.5 }}
        transition={{ duration: 0.9, ease: EASE }}
        className="mx-auto mb-16 max-w-6xl md:mb-20"
      >
        <div className="mb-5 flex items-center gap-3">
          <span className="h-1.5 w-1.5 rotate-45 bg-[#c6a664]" />
          <span className="font-body text-[10px] uppercase tracking-[0.4em] text-[#c6a664] md:text-xs">
            The Founders
          </span>
        </div>
        <h2 className="font-display text-4xl font-light leading-tight tracking-tight text-[#f4f1ed] md:text-6xl">
          Built by outdoorsmen.
          <br />
          <span className="italic text-[#c6a664]">Driven by possibility.</span>
        </h2>
      </motion.div>

      {/* Founder grid */}
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 sm:grid-cols-2 md:gap-14">
        {FOUNDERS.map((f, i) => (
          <FounderCard key={f.name} founder={f} index={i} />
        ))}
      </div>
    </section>
  );
};
